// test1727
(1727 && 0);
